<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
        <header class="card-header">
            <h3 *ngIf="headerTitle" class="text-gray-600 m-0"><i class="fas fa-cubes me-2"></i>{{ headerTitle?.title }}</h3>
        </header>
        <div class="card-body py-5">
            <div class="container">
                <form *ngIf="moduleDetailsFormGroup" (submit)="updateModule()" [formGroup]="moduleDetailsFormGroup">

                            <error-message [errors]="errors"></error-message>

                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Name
                                        </label>
                                        <h6 *ngIf="!isEditMode">{{moduleDetailsFormGroup.value.name}}</h6>
                                        <input *ngIf="isEditMode" type="text" class="form-control" formControlName="name" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label class="control-label">
                                        Is Active
                                    </label>
                                    <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle [isDisabled]="!isEditMode" />
                                </div>
                                <div class="col-md-3 text-end">
                                    <button *ngIf="isEditMode && !moduleQuestionBanks?.length" type="button" class="btn btn-danger mt-4" (click)="selectedModuleId=moduleDetailsFormGroup.value.id; confirmation.showMessage();">Delete Module</button>
                                    <button *ngIf="isEditMode && moduleQuestionBanks?.length>0" type="button" class="btn btn-danger mt-4" (click)="openCannotDeleteModule(cannotDeleteModule);">Delete Module</button>

                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <div class="tabs">
                                        <ul class="nav nav-tabs">
                                            <li class="nav-item">
                                                <a class="nav-link active" href="#popular" data-toggle="tab"> Question Banks</a>
                                            </li>
                                        </ul>
                                        <div class="tab-content">
                                            <div id="popular" class="tab-pane active">
                                                <app-module-question-bank-list (questionBanksUpdated)="questionBanksUpdated()" [moduleId]="moduleId" [isEditMode]="isEditMode"></app-module-question-bank-list>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <footer class="panel-footer mt-3">
                            <div class="row">
                                <div class="col text-end">
                                    <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                                    <button class="btn btn-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                                    <button class="btn btn-outline-primary me-2" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                    <button class="btn btn-success ms-2" type="submit" *ngIf="isEditMode">Save</button>
                                </div>
                            </div>
                        </footer>
                </form>
            </div>
        </div>
    </section>


<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'The Module Updated'">
</app-alert-message>


<app-confirmation-message #confirmation (confirmationClicked)="deleteModule();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this module?'">
</app-confirmation-message>

<ng-template #cannotDeleteModule let-modal>
    <div class="modal-header">
        <div class="container">
            <div class="row">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="modal-title" id="modal-basic-title">Modules containing Question Banks cannot be deleted.</h4>
                        </div>
                        <div class="col-12">
                            <p id="modal-basic-content">Remove all Question Banks to continue.</p>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
